export default __webpack_public_path__ + "static/media/info.748d8c54.svg";